import ShopList from '@/views/shop/shop-list.vue';
import ShopDetail from '@/views/shop/shop-detail.vue';
import ShopTypeList from '@/views/shop/shop-type-list.vue';
import ShopTypeDetail from '@/views/shop/shop-type-detail.vue';

export default [
    {
        path: '/shop/shop-list',
        component: ShopList,
        name: 'shopList'
    },
    {
        path: '/shop/shop-detail',
        component: ShopDetail,
        name: 'shopDetail'
    },
    {
        path: '/shop/shop-type-list',
        component: ShopTypeList,
        name: 'shopTypeList'
    },
    {
        path: '/shop/shop-type-detail',
        component: ShopTypeDetail,
        name: 'shopTypeDetail'
    },
]